export default __webpack_public_path__ + "assets/images/247cd94ad0b7db3f210e436cef0c091d.jpg";